import React from 'react'
import { Navigate } from 'react-router-dom'

export default function NoMatch() {
    return <Navigate to="oops"/>
}
